import React, { Fragment } from "react";
import { Col, Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import { BasicExamples, SuccessNotification, InfoNotification, WarningNotification, DangerNotification } from "../../../Constant";
import { Btn } from "../../../AbstractElements";
import HeaderCard from "../../Common/HeaderCard";

const Basic = () => {
  const basictoaster = (toastname) => {
    switch (toastname) {
      case "basicsuccessToast":
        toast.success("Success Notification !", {
          position: "top-right",
        });
        break;
      case "basicinfoToast":
        toast.info("Info Notification !", {
          position: "top-right",
        });
        break;
      case "basicwarningToast":
        toast.warn("Warning Notification !", {
          position: "top-right",
        });
        break;
      case "basicdangerToast":
        toast.error("Danger Notification !", {
          position: "top-right",
        });
        break;
      default:
        break;
    }
  };
  return (
    <Fragment>
      <Col sm="12">
        <Card>
          <HeaderCard title={BasicExamples} />
          <CardBody className="btn-showcase">
            <Btn name="basicsuccessToast" color="success" onClick={(e) => basictoaster(e.target.name)}>
              {SuccessNotification}
            </Btn>
            <Btn name="basicinfoToast" color="info" onClick={(e) => basictoaster(e.target.name)}>
              {InfoNotification}
            </Btn>
            <Btn name="basicwarningToast" color="warning" onClick={(e) => basictoaster(e.target.name)}>
              {WarningNotification}
            </Btn>
            <Btn name="basicdangerToast" color="danger" onClick={(e) => basictoaster(e.target.name)}>
              {DangerNotification}
            </Btn>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default Basic;
